document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.faq-item');

    items.forEach(item => {
        const title = item.querySelector('h3');
        const p = item.querySelector('p');

        // создаём враппер
        const wrapper = document.createElement('div');
        wrapper.className = 'faq-answer';

        // переносим p внутрь wrapper
        item.insertBefore(wrapper, p);
        wrapper.appendChild(p);

        // стартовое состояние
        wrapper.style.height = '0px';
        wrapper.style.overflow = 'hidden';

        title.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');

            items.forEach(i => {
                i.classList.remove('is-open');
                i.querySelector('.faq-answer').style.height = '0px';
            });

            if (!isOpen) {
                item.classList.add('is-open');
                wrapper.style.height = wrapper.scrollHeight + 'px';
            }
        });
    });
});
